var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { computed, makeObservable, observable, runInAction } from 'mobx';
import { AccommodationList as AccommodationListModel, AccommodationTypeList as AccommodationTypeListModel, } from '@data/models';
import { AccommodationsService, AccommodationsTypeService } from '@data/api';
import TimeUtils from '@business/utils/time';
import { isAllotmentBlockCode } from '@business/utils/promocodes';
import { eventSystem } from '@business/event-system';
import { inventory } from '@business/inventory';
import Store from '../Store';
import { persistentPropertyStorage } from '../PersistentPropertyStorage';
export default class Accommodations {
    constructor() {
        Object.defineProperty(this, "checkin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "checkout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "isLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "model", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "types", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new AccommodationTypeListModel()
        });
        Object.defineProperty(this, "findById", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => this.model.items.find((item) => item.id === id)
        });
        Object.defineProperty(this, "findByPackageId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (packageId) => this.model.items.find((item) => item.packageId === packageId)
        });
        Object.defineProperty(this, "loadAccommodationTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (propertyId) => __awaiter(this, void 0, void 0, function* () {
                if (!propertyId)
                    return;
                // passing a previous dates to get all types
                const result = yield AccommodationsTypeService.load(propertyId);
                runInAction(() => {
                    this.types = result;
                });
                return result;
            })
        });
        Object.defineProperty(this, "search", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (_a) => __awaiter(this, [_a], void 0, function* ({ checkin, checkout, roomTypes, ratePlans, adults, kids, roomIds, }) {
                var _b;
                if (!(this.propertyId && checkin && checkout))
                    return;
                runInAction(() => {
                    this.isLoading = true;
                });
                const _checkin = checkin
                    ? TimeUtils.format(checkin)
                    : TimeUtils.format(TimeUtils.getDateOffset(0));
                const _checkout = checkout
                    ? TimeUtils.format(checkout)
                    : TimeUtils.format(TimeUtils.getDateOffset(1));
                const code = (_b = Store.components.searchPanel.value) === null || _b === void 0 ? void 0 : _b.code;
                const promoCode = {};
                if (code && code.length > 0) {
                    if (isAllotmentBlockCode(code)) {
                        promoCode['allotment_block_code'] = code;
                    }
                    else {
                        promoCode['promo_code'] = code;
                    }
                }
                eventSystem.emit('internal/rooms-availability-requested', {
                    checkin: _checkin,
                    checkout: _checkout,
                    code,
                });
                const result = yield AccommodationsService.search(Object.assign({ checkin: _checkin, checkout: _checkout, currency_code: this.currency, lang: this.language, rate_plan: ratePlans, room_ids: roomIds, room_type: roomTypes, widget_property: this.propertyId }, promoCode));
                let lowestPriceAccommodation;
                if (result === null || result === void 0 ? void 0 : result.items.length) {
                    lowestPriceAccommodation = result === null || result === void 0 ? void 0 : result.items.reduce((acc, item) => {
                        return acc.rate < item.rate ? acc : item;
                    });
                }
                eventSystem.emit('availability-searched', {
                    bestPrice: (lowestPriceAccommodation === null || lowestPriceAccommodation === void 0 ? void 0 : lowestPriceAccommodation.rate) || 0,
                    bestPriceRoomName: (lowestPriceAccommodation === null || lowestPriceAccommodation === void 0 ? void 0 : lowestPriceAccommodation.name) || '',
                    checkin: _checkin,
                    checkout: _checkout,
                    code,
                    currencyCode: this.currency,
                    numOfAdults: adults,
                    numOfChildren: kids,
                    numOfNights: TimeUtils.getDiff(_checkout, _checkin),
                    rateId: (lowestPriceAccommodation === null || lowestPriceAccommodation === void 0 ? void 0 : lowestPriceAccommodation.rateId) || '',
                    roomId: (lowestPriceAccommodation === null || lowestPriceAccommodation === void 0 ? void 0 : lowestPriceAccommodation.id) || '',
                }, { visibility: 'external' });
                runInAction(() => {
                    this.checkin = _checkin;
                    this.checkout = _checkout;
                    this.model = result;
                    this.isLoading = false;
                });
                // Preload room amenities for card display (fire-and-forget; MobX reactivity handles UI updates)
                if (Store.property.amenities.isUsingNewAmenitiesSystem && result) {
                    const uniqueRoomIds = [...new Set(result.items.map((item) => item.id))];
                    uniqueRoomIds.forEach((id) => Store.property.amenities.loadRoomAmenities(id).catch(() => {
                        // Silently swallow — pills simply won't render for this room
                    }));
                }
                inventory.recalculate({ cartItems: Store.property.cart.accommodations });
                return result;
            })
        });
        this.model = new AccommodationListModel();
        makeObservable(this);
    }
    get storageKey() {
        return 'accommodations';
    }
    load() {
        const loadedData = persistentPropertyStorage.getItem(this.storageKey);
        if (loadedData) {
            const parsedData = JSON.parse(loadedData);
            this.checkin = parsedData.checkin;
            this.checkout = parsedData.checkout;
            this.model = parsedData.model;
            this.types.loadItems(parsedData.types);
        }
    }
    save() {
        persistentPropertyStorage.setItem(this.storageKey, JSON.stringify(this));
    }
    get language() {
        return Store.environment.language || 'en';
    }
    get currency() {
        return Store.environment.currency || 'usd';
    }
    get propertyId() {
        var _a;
        return (_a = Store.property.model) === null || _a === void 0 ? void 0 : _a.id;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], Accommodations.prototype, "checkin", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Accommodations.prototype, "checkout", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Accommodations.prototype, "isLoading", void 0);
__decorate([
    observable,
    __metadata("design:type", AccommodationListModel)
], Accommodations.prototype, "model", void 0);
__decorate([
    observable,
    __metadata("design:type", AccommodationTypeListModel)
], Accommodations.prototype, "types", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Accommodations.prototype, "language", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Accommodations.prototype, "currency", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Accommodations.prototype, "propertyId", null);
